//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fileImageApi } from '@/api/systemSetting';
export default {
  props: {
    image: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    close: function close(index) {
      this.image.splice(index, 1);
      this.$emit('handleImage', this.image);
    },
    // 弹窗标签结束
    // 上传头像
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this = this;

      var formData = new FormData(); // if (param.file.size / (1024 * 1024).toFixed(2) >= 1) {
      //   this.$message.error('图片最大不能超过1Mb')
      //   return
      // }

      var data = {
        // model: this.modelName ? this.modelName : this.$route.path.split('/')[1],
        // pid: this.tableData.pid
        fileTypeCode: 'img'
      };
      formData.append('file', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      fileImageApi(formData, data, undefined).then(function (res) {
        if (!_this.image) {
          _this.image = [];
        }

        loading.close();

        _this.image.push(res.url);

        _this.$emit('handleImage', _this.image);

        _this.$message.success('上传成功');
      }).catch(function (res) {
        loading.close();
      });
    }
  }
};